import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PageCategory from './views/PageCategory.vue'
import CryptoFashion from './views/CryptoFashion.vue'

import SingleApocalypseWow from './components/SingleApocalypseWow.vue';
import SingleCryptoPoster from './components/SingleCryptoPoster.vue';

import Page from "./views/Page.vue";
import CoinClothing from "./views/CoinClothing.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: "Home",
      component: Home
    },
    {
      path: '/dogecoin/apocalypse-wow-meme-t-shirt',
      name: "SingleApocalypseWow",
      component: SingleApocalypseWow
    },
    {
      path: '/crypto-fashion/crypto-logos-poster',
      name: "CryptoLogosPoster",
      component: SingleCryptoPoster
    },
    {
      path: '/crypto-dresses',
      name: "CryptoDresses",
      component: PageCategory,
    },
    {
      path: '/crypto-t-shirts',
      name: "CryptoTshirts",
      component: PageCategory
    },
    {
      path: '/crypto-hoodies',
      name: "CryptoHoodies",
      component: PageCategory
    },
    {
      path: '/crypto-sweatshirts',
      name: "CryptoSweatshirts",
      component: PageCategory
    },
    {
      path: '/crypto-longsleeve-t-shirts',
      name: "CryptoLongsleeveTshirts",
      component: PageCategory
    },
    {
      path: '/crypto-laptop-cases',
      name: "CryptoLaptopSleeves",
      component: PageCategory
    },
    {
      path: '/crypto-mugs',
      name: "CryptoMugs",
      component: PageCategory
    },
    {
      path: '/crypto-stickers',
      name: "CryptoStickers",
      component: PageCategory
    },
    {
      path: '/crypto-backpacks',
      name: "CryptoBackpacks",
      component: PageCategory
    },
    {
      path: '/crypto-face-masks',
      name: "CryptoMasks",
      component: PageCategory
    },
    {
      path: '/crypto-fashion',
      name: "CryptoFashion",
      component: CryptoFashion
    },
    {
      path: '/shopping-cart',
      name: "ShoppingCart",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: Page
    },
    {
      path: "/terms-and-conditions",
      name: "terms-and-conditions",
      component: Page
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: Page
    },
    {
      path: "/shipping",
      name: "shipping",
      component: Page
    },
    {
      path: "/contacts",
      name: "contacts",
      component: Page
    },
    {
      path: "/payment-success",
      name: "payment-success",
      component: Page
    },
    {
      path: "/payment-declined",
      name: "payment-declined",
      component: Page
    },
    {
      path: "/:coinId",
      name: "CoinClothing",
      component: CoinClothing
    },
    {
      path: "/:coinId/t-shirt",
      name: "CoinClothingTshirt",
      component: CoinClothing,
    },
    {
      path: "/:coinId/longsleeve-t-shirt",
      name: "CoinClothingLongsleeveTshirt",
      component: CoinClothing,
    },
    {
      path: "/:coinId/laptop-sleeve",
      name: "CoinClothingLaptopSleeve",
      component: CoinClothing,
    },
    {
      path: "/:coinId/hodl-t-shirt",
      name: "CoinClothingHodlTshirt",
      component: CoinClothing,
    },
    {
      path: "/:coinId/dress",
      name: "CoinClothingDress",
      component: CoinClothing,
    },
    {
      path: "/:coinId/hoodie",
      name: "CoinClothingHoodie",
      component: CoinClothing,
    },
    {
      path: "/:coinId/sweatshirt",
      name: "CoinClothingSweatshirt",
      component: CoinClothing,
    },
    {
      path: "/:coinId/coffee-mug",
      name: "CoinClothingMug",
      component: CoinClothing,
    },
    {
      path: "/:coinId/sticker",
      name: "CoinClothingSticker",
      component: CoinClothing,
    },
    {
      path: "/:coinId/backpack",
      name: "CoinClothingBackpack",
      component: CoinClothing,
    },
    {
      path: "/:coinId/neck-gaiter",
      name: "CoinClothingMask",
      component: CoinClothing,
    },
  ]
})
